export default "__VITE_ASSET__CyIae40l__"